import { captureException } from '@sentry/react'

type CaptureExceptionParams = Parameters<typeof captureException>
type Hints = CaptureExceptionParams[1]

function getError(error: unknown) {
  if (typeof error === 'string') {
    return new Error(error)
  }

  if (typeof error === 'object') {
    try {
      const json = JSON.stringify(error)
      return new Error(json)
    } catch {
      // NOOP: fallback to generic error
    }
  }

  return new Error(`Cannot derive error from ${error}`)
}

export function handleError(error: unknown, hints?: Hints) {
  if (!error) {
    return
  }

  captureException(getError(error), hints)
}
